"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CancelButton = CancelButton;
const components_1 = require("@alcumus/components");
const core_1 = require("@material-ui/core");
const clsx_1 = __importDefault(require("clsx"));
const react_i18next_1 = require("react-i18next");
const react_1 = __importDefault(require("react"));
const useStyles = (0, core_1.makeStyles)(() => ({
    buttonBase: {
        borderRadius: 205,
        padding: '8px 24px',
    },
    buttonText: {
        fontWeight: components_1.StyleVariables.fonts.weight.semiBold,
        lineHeight: components_1.StyleVariables.fonts.lineHeight.h5,
    },
}));
function CancelButton({ onClick, className }) {
    const classes = useStyles();
    const { t } = (0, react_i18next_1.useTranslation)(['translation', 'AriaLabels']);
    return (react_1.default.createElement(components_1.Button, { "aria-label": t('cancel', { ns: 'AriaLabels' }), uppercase: false, rounded: true, className: (0, clsx_1.default)(classes.buttonBase, className), size: "medium", "data-testid": "cancelButton", variant: "outlined", onClick: (e) => onClick && onClick(e) },
        react_1.default.createElement(components_1.Text, { center: true, className: classes.buttonText }, t('cancel', { ns: 'translation' }))));
}
